import { APP_URLS } from 'constants/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getTasksBreadcrumbMap({
  pathname,
  t,
  entity,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });
  const tasksItem = {
    label: t('tasks'),
    path: APP_URLS.dashboard.tasks.index.getPathWithQuery(),
  };
  const taskDetailsItem = {
    label: t('task-details'),
    path: APP_URLS.dashboard.tasks.view.getDynamicPath({
      pathParts: {
        id: `${entity?.id}`,
      },
    }),
  };

  return [
    {
      condition: APP_URLS.dashboard.tasks.index.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('tasks'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.tasks.add.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        tasksItem,
        {
          label: t('create-task'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.tasks.edit.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        tasksItem,
        taskDetailsItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.tasks.duplicate.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        tasksItem,
        {
          label: t('duplicate-task'),
          path: taskDetailsItem.path,
        },
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.tasks.view.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        tasksItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.tasks.formView.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        tasksItem,
        taskDetailsItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.tasks.reporting.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        tasksItem,
        taskDetailsItem,
        {
          label: t('reporting'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.tasks.interventions.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        tasksItem,
        taskDetailsItem,
        {
          label: t('interventions'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.tasks.approvals.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('approvals'),
        },
      ],
    },
  ];
}
